<template>
  <div>
    <section class="page-content rx-page-application">
      <div class="row">
        <div class="col-md-12">
          <form action @submit.prevent="next">
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="mr-1">10.</span>What state(s) are you licensed in?
              </label>
              <div class="row pb-3">
                <div class="col-md-4">
                  <input
                      type="text"
                      name="licensedStateOne"
                      v-model="mgaApplication.licensedStateOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-4">
                  <input
                      type="text"
                      name="licensedStateTwo"
                      v-model="mgaApplication.licensedStateTwo"
                      class="orep-text-input w-100"
                  >
                </div>
                <div class="col-md-4">
                  <input
                      type="email"
                      name="licensedStateThree"
                      v-model="mgaApplication.licensedStateThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-4">
                  <label for class="orep-label mb-0">
                    <span class="qtn mrpx-5"></span>Licensed Since
                  </label>
                  <input
                      type="text"
                      name="licensedSince"
                      v-model="mgaApplication.licensedSince"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>
            </article>
            <article class="input-section form-section">
              <label for class="orep-label">
                <span class="mr-1">9.</span> Staffing:
              </label>
              <div class="table-responsive hc-table inputs-table">
                <table class="table">
                  <tbody>
                  <tr class="title-row">
                    <td></td>
                    <td>Full Time </td>
                    <td>Part Time</td>
                    <td>Licensed</td>
                  </tr>
                  <tr>
                    <td class="td-res right-border">a. Active owners, partners, officers or directors:</td>
                    <td>
                      <input
                        type="number"
                        oninput="this.value=(parseInt(this.value)||0)"
                        class="orep-text-input js-orep-input table-text-input"
                        name="activeOwnerFullTime"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="activeOwnerFullTime"
                    >
                    </td>
                    <td>
                      <input
                        type="number"
                        oninput="this.value=(parseInt(this.value)||0)"
                        class="orep-text-input js-orep-input table-text-input"
                        name="activeOwnerPartTime"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="activeOwnerPartTime"
                    >
                    </td>
                    <td>
                      <input
                        type="number"
                        oninput="this.value=(parseInt(this.value)||0)"
                        class="orep-text-input js-orep-input table-text-input"
                        name="activeOwnerLicensed"
                        v-validate="'numeric'"
                        placeholder="0"
                        @input="validateBeforeSubmit()"
                        v-model="activeOwnerLicensed"
                    >
                    </td>
                  </tr>
                  <tr>
                    <td class="td-res right-border">b. Underwriters excluding those in a:</td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="underwritersFullTime"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="underwritersFullTime"
                      >
                    </td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="underwritersPartTime"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="underwritersPartTime"
                      >
                    </td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="underwritersLicensed"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="underwritersLicensed"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="td-res right-border">c. Licensed agents, brokers, and solicitors:</td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="licensedAgentFullTime"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="licensedAgentFullTime"
                      >
                    </td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="licensedAgentPartTime"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="licensedAgentPartTime"
                      >
                    </td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="licensedAgentLicensed"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="licensedAgentLicensed"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="td-res right-border">d. All other full-time staff:</td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="otherFullTime"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="otherFullTime"
                      >
                    </td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="otherPartTime"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="otherPartTime"
                      >
                    </td>
                    <td>
                      <input
                          type="number"
                          oninput="this.value=(parseInt(this.value)||0)"
                          class="orep-text-input js-orep-input table-text-input"
                          name="otherLicensed"
                          v-validate="'numeric'"
                          placeholder="0"
                          @input="validateBeforeSubmit()"
                          v-model="otherLicensed"
                      >
                    </td>
                  </tr>
                  <tr>
                    <td class="td-res right-border">Total</td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input js-orep-input table-text-input"
                          disabled
                          v-model="$store.getters['mgaApplication/totalFullTime']"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input js-orep-input table-text-input"
                          disabled
                          v-model="$store.getters['mgaApplication/totalPartTime']"
                      >
                    </td>
                    <td>
                      <input
                          type="text"
                          class="orep-text-input js-orep-input table-text-input"
                          disabled
                          v-model="$store.getters['mgaApplication/totalLicensed']"
                      >
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </article>

            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">  PRIOR E & 0 COVERAGE </h1>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">1. </span>
                    Do you currently have E&O Coverage?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="doYouhaveEoCoverage"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.doYouhaveEoCoverage"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="doYouhaveEoCoverage"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.doYouhaveEoCoverage"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('doYouhaveEoCoverage')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('doYouhaveEoCoverage') | filterText }}</span>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4 col-sm-12">
                  <label for class="orep-label mb-0 ml-1">
                    What is the expiration date?
                  </label>
                </div>
                <div class="col-md-8 col-sm-12">
                  <datepicker
                      name="expirationDate"
                      v-model="mgaApplication.expirationDate"
                      format="MM/dd/yyyy"
                      input-class="orep-text-input-date"
                      @input="validateBeforeSubmit()"
                      :clearButton="false"
                      :value="computedDates"
                  ></datepicker>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-md-4 col-sm-12">
                  <label for class="orep-label mb-0 ml-1">
                    What is the retroactive date?
                  </label>
                </div>
                <div class="col-md-8 col-sm-12">
                  <input type="text"
                         name="retroactiveDate"
                         v-model="mgaApplication.retroactiveDate"
                         class="orep-text-input-date"
                         placeholder="MM/dd/yyyy"
                         @input="validateBeforeSubmit()"
                         required>
                </div>
              </div>
            </article>

            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">2. </span>
                    Who were you previously insured by?
                  </label>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto   d-flex flex-column align-items-center">
                  <label for class="orep-label">
                    Insurer
                  </label>
                  <input
                      type="text"
                      id="insurerOne"
                      name="insurerOne"
                      v-model="mgaApplication.insurerOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Policy Period
                  </label>
                  <input
                      type="text"
                      id="policyPeriodOne"
                      name="policyPeriodOne"
                      v-model="mgaApplication.policyPeriodOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Limit
                  </label>
                  <input
                      type="text"
                      id="limitOne"
                      name="limitOne"
                      v-model="mgaApplication.limitOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <label for class="orep-label">
                    Deductible
                  </label>
                  <input
                      type="text"
                      id="deductibleOne"
                      name="deductibleOne"
                      v-model="mgaApplication.deductibleOne"
                      class="orep-text-input w-100"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center">
                  <label for class="orep-label">
                    Premium
                  </label>
                  <input
                      type="text"
                      id="premiumOne"
                      name="premiumOne"
                      v-model="mgaApplication.premiumOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto   d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="insurerTwo"
                      name="insurerTwo"
                      v-model="mgaApplication.insurerTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="policyPeriodTwo"
                      name="policyPeriodTwo"
                      v-model="mgaApplication.policyPeriodTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="limitTwo"
                      name="limitTwo"
                      v-model="mgaApplication.limitTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="deductibleTwo"
                      name="deductibleTwo"
                      v-model="mgaApplication.deductibleTwo"
                      class="orep-text-input w-100"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="premiumTwo"
                      name="premiumTwo"
                      v-model="mgaApplication.premiumTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-auto   d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="insurerThree"
                      name="insurerThree"
                      v-model="mgaApplication.insurerThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="policyPeriodThree"
                      name="policyPeriodThree"
                      v-model="mgaApplication.policyPeriodThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="limitThree"
                      name="limitThree"
                      v-model="mgaApplication.limitThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="deductibleThree"
                      name="deductibleThree"
                      v-model="mgaApplication.deductibleThree"
                      class="orep-text-input w-100"
                  >
                </div>
                <div class="col-md-2 d-flex flex-column align-items-center">
                  <input
                      type="text"
                      id="premiumThree"
                      name="premiumThree"
                      v-model="mgaApplication.premiumThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>

            </article>


            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">3.</span>
                    Has your E&O insurance ever been cancelled, renewal refused, or coverage declined?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="hasEoInsuranceDeclined"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.hasEoInsuranceDeclined"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="hasEoInsuranceDeclined"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.hasEoInsuranceDeclined"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('hasEoInsuranceDeclined')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('hasEoInsuranceDeclined') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.hasEoInsuranceDeclined == true || mgaApplication.hasEoInsuranceDeclined === 'true'">
                <label class="orep-label text-danger">If Yes, provide details
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.hasEoInsuranceDeclined == true || mgaApplication.hasEoInsuranceDeclined === 'true'"
                    name="hasEoInsuranceDeclinedDetails"
                    v-model="mgaApplication.hasEoInsuranceDeclinedDetails"
                >
              </div>
            </article>

            <article class="form-heading title-section form-section flex">
              <h1 class="form-title">  PREMIUM WRITTEN AND COMMISSIONS </h1>
            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-10">
                  <label for class="orep-label">
                    <span class="mr-1">1. </span>
                    How much premium did you write last year and what do you estimate over the next 12 months?
                  </label>
                </div>
              </div>
              <table class="w-100">
                <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Previous Complete
                    Calendar Year</th>
                  <th colspan="2">Estimate: next 12 Months</th>
                </tr>
                </thead>
                <tbody>
                <th>
                  Premium:
                </th>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="periodOne"
                        name="periodOne"
                        v-model="mgaApplication.periodOne"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="periodTwo"
                        name="periodTwo"
                        v-model="mgaApplication.periodTwo"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                </tbody>
              </table>
            </article>

            <article class="input-section form-section">
              <div class="row">
                <label for class="orep-label">
                  <span class="mr-1">2. </span>
                  How much commission did you earn last year and what do you estimate over the next 12 months?
                </label>
              </div>
              <table class="w-100">
                <thead>
                <tr>
                  <th></th>
                  <th colspan="2">Previous Complete
                    Calendar Year
                  </th>
                  <th colspan="2">Estimate: next 12 Months</th>
                </tr>
                </thead>
                <tbody>
                <th>
                  Commission:
                </th>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="estimateCommissionEarnOne"
                        name="estimateCommissionEarnOne"
                        v-model="mgaApplication.estimateCommissionEarnOne"
                        v-validate="'required'"
                        class="orep-text-input w-100"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                <td colspan="2">
                  <div class="align-items-center"> <!-- Added align-items-center class -->
                    <input
                        type="number"
                        id="estimateCommissionEarnTwo"
                        name="estimateCommissionEarnTwo"
                        v-model="mgaApplication.estimateCommissionEarnTwo"
                        class="orep-text-input w-100"
                        v-validate="'required'"
                        @input="validateBeforeSubmit()"
                    >
                  </div>
                </td>
                </tbody>
              </table>

            </article>

            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-10">
                  <label for class="orep-label">
                    <span class="mr-1">2B. </span>
                     How much commission did you pay to producers?                  </label>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-3 d-flex flex-column align-items-center">
                  <label for class="orep-label">
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="estimateCommissionPaidOne"
                      name="estimateCommissionPaidOne"
                      v-model="mgaApplication.estimateCommissionPaidOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="estimateCommissionPaidTwo"
                      name="estimateCommissionPaidTwo"
                      v-model="mgaApplication.estimateCommissionPaidTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="estimateCommissionPaidThree"
                      name="estimateCommissionPaidThree"
                      v-model="mgaApplication.estimateCommissionPaidThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>

            </article>
            <article class="input-section form-section">
              <div class="row">
                <div class="col-md-10">
                  <label for class="orep-label">
                    <span class="mr-1">2C. </span>
                    Net commission retained:?
                  </label>
                </div>
              </div>
              <div class="row pb-3">
                <div class="col-md-3 d-flex flex-column align-items-center">
                  <label for class="orep-label">
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="noCommissionRetainedOne"
                      name="noCommissionRetainedOne"
                      v-model="mgaApplication.noCommissionRetainedOne"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="noCommissionRetainedTwo"
                      name="noCommissionRetainedTwo"
                      v-model="mgaApplication.noCommissionRetainedTwo"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
                <div class="col-md-3 d-flex flex-column align-items-center"> <!-- Added align-items-center class -->
                  <input
                      type="text"
                      id="noCommissionRetainedThree"
                      name="noCommissionRetainedThree"
                      v-model="mgaApplication.noCommissionRetainedThree"
                      class="orep-text-input w-100"
                      @input="validateBeforeSubmit()"
                  >
                </div>
              </div>

            </article>

            <article class="input-section form-section d-flex flex-column">
              <div class="row">
                <div class="col-md-9 col-sm-12">
                  <label for class="orep-label">
                    <span class="mr-1">3.</span>
                    Do you specialize in any specific class of business?
                  </label>
                </div>
                <div class="col-md-3 d-flex flex-column">
                  <div class="d-flex flex-row">
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="specializeInAnyBusiness"
                            value="true"
                            class="orep-radio"
                            v-validate="'required'"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.specializeInAnyBusiness"
                        >
                        <span class="radio-span">Yes</span>
                      </label>
                    </div>
                    <div class="radio orep-radio-wrapper">
                      <label>
                        <input
                            type="radio"
                            name="specializeInAnyBusiness"
                            value="false"
                            class="orep-radio"
                            @change="validateBeforeSubmit()"
                            v-model="mgaApplication.specializeInAnyBusiness"
                        >
                        <span class="radio-span">No</span>
                      </label>
                    </div>
                  </div>
                  <span
                      v-show="errors.has('specializeInAnyBusiness')"
                      class="help is-danger form-errors text-danger"
                  >{{ errors.first('specializeInAnyBusiness') | filterText }}</span>
                </div>
              </div>
              <div class="col-md-auto d-flex flex-column" v-if="mgaApplication.specializeInAnyBusiness == true || mgaApplication.specializeInAnyBusiness === 'true'">
                <label class="orep-label text-danger">If Yes, provide details
                </label>

                <input
                    type="text"
                    placeholder="Please explain:"
                    class="orep-text-input js-orep-input"
                    v-if="mgaApplication.specializeInAnyBusiness == true || mgaApplication.specializeInAnyBusiness === 'true'"
                    name="specializeInAnyBusinessDetails"
                    v-model="mgaApplication.specializeInAnyBusinessDetails"
                >
              </div>
            </article>
          </form>
        </div>
      </div>
    </section>
    <div class="row">
      <div class="col-md-12">
        <section class="flex wrap bottom-section">
          <router-link :to="{name:'ibdpro-mga-application-1'}" class="next-btn back-btn flex mont spaced">
            <i class="fas fa-arrow-left"></i>
            Back
          </router-link>
          <article class="orep-pagination">
            <button @click="prev()" class="pagination-dots"></button>
            <button class="pagination-dots pagination-current"></button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid"
              @click="navigateToNext('ibdpro-mga-application-3')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid"
              @click="navigateToNext('ibdpro-mga-application-4')">
            </button>
            <button
              class="pagination-dots"
              :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid"
              @click="navigateToNext('pageTwoIsValid-appraiser-5')">
            </button>
            <button
                class="pagination-dots"
                :disabled="!state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid"
                @click="navigateToNext('pageTwoIsValid-appraiser-6')">
            </button>
            <button
                class="pagination-dots"
                @click="navigateToNext('ibdpro-mga-application-7')"
                :disabled="!state.pageOneIsValid || !state.pageTwoIsValid || !state.pageThreeIsValid || !state.pageFourIsValid || !state.pageFiveIsValid || !state.pageSixIsValid">
            </button>
          </article>
          <button type="submit" :disabled="!state.pageTwoIsValid"
            :class="{submitDisabled: !state.pageTwoIsValid}" class="next-btn mont spaced pull-right" @click="navigateToNext('ibdpro-mga-application-3')">Next</button>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import $ from "jquery";
import moment from "moment/moment";
import Datepicker from "vuejs-datepicker";
import {STATES} from "@/utils/constants";

export default {
  name: "ibdpro-mga-application-2",
  data() {
    return {
      states: STATES
    };
  },
  computedDates() {
    return moment(this.value).format('YYYY-MM-D')
  },
  computed: {
    mgaApplication() {
      return this.$store.state.mgaApplication.mgaApplication;
    },
    state() {
      return this.$store.state.mgaApplication;
    },
    errorMsg() {
      return this.$store.state.mgaApplication.errorMsg;
    },

    activeOwnerFullTime: {
      get() {
        return this.mgaApplication.activeOwnerFullTime || '';
      },
      set(val) {
        this.mgaApplication.activeOwnerFullTime = val;
      },
    },

    activeOwnerPartTime: {
      get() {
        return this.mgaApplication.activeOwnerPartTime || '';
      },
      set(val) {
        this.mgaApplication.activeOwnerPartTime = val;
      },
    },

    activeOwnerLicensed: {
      get() {
        return this.mgaApplication.activeOwnerLicensed || '';
      },
      set(val) {
        this.mgaApplication.activeOwnerLicensed = val;
      },
    },

    underwritersFullTime: {
      get() {
        return this.mgaApplication.underwritersFullTime || '';
      },
      set(val) {
        this.mgaApplication.underwritersFullTime = val;
      },
    },

    underwritersPartTime: {
      get() {
        return this.mgaApplication.underwritersPartTime || '';
      },
      set(val) {
        this.mgaApplication.underwritersPartTime = val;
      },
    },

    underwritersLicensed: {
      get() {
        return this.mgaApplication.underwritersLicensed || '';
      },
      set(val) {
        this.mgaApplication.underwritersLicensed = val;
      },
    },

    licensedAgentFullTime: {
      get() {
        return this.mgaApplication.licensedAgentFullTime || '';
      },
      set(val) {
        this.mgaApplication.licensedAgentFullTime = val;
      },
    },

    licensedAgentPartTime: {
      get() {
        return this.mgaApplication.licensedAgentPartTime || '';
      },
      set(val) {
        this.mgaApplication.licensedAgentPartTime = val;
      },
    },

    licensedAgentLicensed: {
      get() {
        return this.mgaApplication.licensedAgentLicensed || '';
      },
      set(val) {
        this.mgaApplication.licensedAgentLicensed = val;
      },
    },

    otherFullTime: {
      get() {
        return this.mgaApplication.otherFullTime || '';
      },
      set(val) {
        this.mgaApplication.otherFullTime = val;
      },
    },

    otherPartTime: {
      get() {
        return this.mgaApplication.otherPartTime || '';
      },
      set(val) {
        this.mgaApplication.otherPartTime = val;
      },
    },

    otherLicensed: {
      get() {
        return this.mgaApplication.otherLicensed || '';
      },
      set(val) {
        this.mgaApplication.otherLicensed = val;
      },
    },

  },
  watch: {
    errorMsg: {
      handler() {
        if (this.errorMsg) {
          this.$notify({
            group: 'error',
            type: 'error',
            text: this.errorMsg,
            duration: 15000
          });
        }
      }
    }
  },
  methods: {
    prev() {
      this.$router.push({
        name: "ibdpro-mga-application-1"
      });
    },

    navigateToNext(routeName) {
      this.$router.push({
        name: routeName
      });
    },

    validateBeforeSubmit() {
      this.mgaApplication.sumOfPeriod =
          Number(this.mgaApplication.periodOne) +
          Number(this.mgaApplication.periodTwo);

      this.mgaApplication.sumOfComission =
          Number(this.mgaApplication.estimateCommissionEarnOne) +
          Number(this.mgaApplication.estimateCommissionEarnTwo);
      this.$validator.validateAll().then(result => {
        if (result) {
          this.state.pageTwoIsValid = true;
          return;
        }
        this.state.pageTwoIsValid = false;
      });
    },
    validateBeforeSubmitCheck(e){
      this.mgaApplication.sumOfPeriod =
          Number(this.mgaApplication.periodOne) +
          Number(this.mgaApplication.periodTwo);

      this.mgaApplication.sumOfComission =
          Number(this.mgaApplication.estimateCommissionEarnOne) +
          Number(this.mgaApplication.estimateCommissionEarnTwo);

      this.$validator.validateAll().then(result => {
        if (result) {
          if (this.state.mgaApplication.realEstateAgentBroker === true){
            this.state.pageTwoIsValid = true;
          }
          else {
          this.state.pageTwoIsValid = false;
          this.validateBeforeSubmit();
          }
          return;
        }
        this.state.pageTwoIsValid = true;

      });
    },
  },

  mounted() {
    $("html, body").animate(
      {
        scrollTop: $(".page-content").offset().top
      },
      500
    );
  },

  filters: {
    filterText(x) {
      if (x !== undefined) {
        if (x.indexOf("req") !== -1) {
          return "This field is required";
        } else {
          return x.replace("_", " ");
        }
      }
    }
  },
  components: {
    Datepicker
  }
};
</script>

<style scoped>
  .red-text {
    color: red;
  }
  table td, table th {
    border: 1px solid black;
  }
  table th {
    height: 35px;
  }
  table td:not(:first-child), table th:not(:first-child) {
    text-align: center;
    max-width: 140px;
  }
  table input {
    width: 100%;
    text-align: center;
  }
</style>
